import { classes } from '../../../utils/class-utils';

export const containerStyles = classes(['flex', 'justify-center', 'items-center', 'gap-2']);

export const dotStyles = classes(['w-2', 'h-2', 'rounded-full', 'transition-all', 'duration-300', 'hover:bg-gray-400']);

export const dotStateStyles = {
  active: classes(['bg-gray-800']),
  inactive: classes(['bg-gray-300']),
};
